import { Component, input, output } from '@angular/core';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { TranslatePipe } from '@ngx-translate/core';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

@Component({
  selector: 'ocp-create-card',
  imports: [HlmCardImports, TranslatePipe, ThemedIconComponent],
  templateUrl: './create-card.component.html',
  styleUrl: './create-card.component.scss',
})
export class CreateCardComponent {
  label = input('teams.create-new-team');
  create = output<void>();
}
